import { Beer, Bike, BookOpen, Bus, CalendarDays, Car, Flag, Footprints, GraduationCap, Moon, Navigation, Repeat, User } from 'lucide-react';
import type { CalendarItem } from '@tempo/core';

export function ModeIcon({ mode, size = 16 }: { mode: string | null | undefined; size?: number }) {
  switch (mode) {
    case 'walk':
      return <Footprints size={size} />;
    case 'cycle':
      return <Bike size={size} />;
    case 'drive':
      return <Car size={size} />;
    case 'transit':
      return <Bus size={size} />;
    default:
      return <Navigation size={size} />;
  }
}

export function ItemIcon({ item, size = 16 }: { item: CalendarItem; size?: number }) {
  switch (item.kind) {
    case 'travel':
      return <ModeIcon mode={item.mode} size={size} />;
    case 'routine':
      return <Repeat size={size} />;
    case 'task':
      return <BookOpen size={size} />;
    case 'sleep':
      return <Moon size={size} />;
    case 'deadline':
      return <Flag size={size} />;
    default:
      if (item.category === 'work') return <Beer size={size} />;
      if (item.category === 'uni') return <GraduationCap size={size} />;
      if (item.category === 'personal') return <User size={size} />;
      return <CalendarDays size={size} />;
  }
}

export const KIND_LABEL: Record<string, string> = {
  event: 'Event',
  deadline: 'Deadline',
  routine: 'Routine',
  task: 'Study / task session',
  travel: 'Travel',
  sleep: 'Sleep',
};

export function FlagBadges({ item }: { item: CalendarItem }) {
  return (
    <>
      {item.flags.includes('shortened') && <span className="badge warn">shortened</span>}
      {item.flags.includes('pinned') && <span className="badge accent">moved today</span>}
      {item.flags.includes('split') && <span className="badge">part</span>}
      {item.flags.includes('conflict') && <span className="badge danger">can't make it</span>}
      {item.flags.includes('late') && item.kind === 'travel' && <span className="badge danger">leave now</span>}
      {item.status === 'done' && item.kind !== 'travel' && <span className="badge ok">done</span>}
      {item.status === 'missed' && <span className="badge danger">missed</span>}
    </>
  );
}
